import { gql } from '@apollo/client';

export const GET_SUB_ACCOUNT_HIDDEN_PAGES = gql`
  query GetSubAccountHiddenPages {
    tm {
      tenant {
        config {
          subAccountHiddenPages
        }
      }
    }
  }
`;
